<template>
  <carousel
    :per-page="1"
    :scroll-per-page="scrollPerPage"
    :per-page-custom="perPageCustom"
    :pagination-enabled="false"
    navigation-enabled
    navigation-next-label="<i class='icon-chevron-right'></i>"
    navigation-prev-label="<i class='icon-chevron-left'></i>"
    class="mb-5"
  >
    <slide v-for="(item, i) in list" :key="i" class="pr-3">
      <slot :data="item"></slot>
    </slide>
  </carousel>
</template>
<script>
import isMobile from "ismobilejs";
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    perPageCustom: {
      type: Array,
      default: () => [
        [200, 1.5],
        [400, 2],
        [600, 3],
        [800, 4],
        [1280, 4.3],
        [1500, 5]
      ]
    }
  },
  computed: {
    scrollPerPage() {
      return !isMobile().any; // if is in mobile pass false
    }
  }
};
</script>
